module.exports = __webpack_public_path__ + "img/金融投资行业.b53d13a0.png";